import { SafeHtml } from '@angular/platform-browser';

export interface Contenido {
	id: number,
	rid: string,
	categoria: string,
	titulo: string,
	desc: string,
	imagen: string,
	destacado: boolean,
	tipo: string,
	fechaUltimaModif: Date,
	fechaPublicacion: Date,
	fechaFin: Date,
	detalle?: string,
	html?: SafeHtml		// Este campo es igual al campo detalle excepto que es de tipo SafeHtml
}

export interface Revista {
	id: number,
	mes: string,
	anio: number,
	portadaUrl: string,
	url: string
}

export interface ContenidoStatus {
	lastUpdate: Date,
	qty: number
}

// Beneficio

export interface Beneficio {
	id: number,
	rid: string,
	categoria: BeneficioCategoria,
	empresa: string,
	logo: string,
	acumulable: boolean,
	fechaPublicacion: Date,
	promos: BeneficioPromo[]
}

export interface BeneficioDetalle extends Beneficio {
	imagen: string,
	direccion: string,
	telefono: string,
	sitioWeb: string,
	email: string,
	facebook: string,
	instagram: string
	validoHasta: Date,
	detalle: string,
	html?: SafeHtml		// Este campo es igual al campo detalle excepto que es de tipo SafeHtml
}

export interface BeneficioPromo {
	id: number,
	valor: string,
	hasta: boolean,
	desc: string,
	tipo: BeneficioPromoTypes,
	showData: string
}

export enum BeneficioPromoTypes {
	PORCENTAJE_OFF = "porcentaje_off",
	CUOTAS = "cuotas",
	MONTO_FIJO = "monto_fijo",
	LLEVA_X_PAGA_Y = "lleva_x_paga_y",
	ESPECIAL = "especial"
}

export interface BeneficioCategoria {
	id: number,
	tipo: string,
	desc: string
}

export const beneficioCategoriaTodos: BeneficioCategoria = { id: -1, tipo: 'TODOS', desc: 'Todos' };


// Salutación

export enum SalutacionTipografia { SANS_SERIF, SERIF, CALIGRAFICA };
export enum SalutacionAlineacion { LEFT, CENTER, RIGHT };

export interface Salutacion {
	id: number,
	rid: string,
	tipografia: SalutacionTipografia,
	alineacion: SalutacionAlineacion,
	color: string,
	fondo: string,
	saludo: string,
	incluyeNota: boolean
}

export const AlineacionToJustifyContent: { [k:string]: string } = {};
AlineacionToJustifyContent[ SalutacionAlineacion[ SalutacionAlineacion.LEFT ] ] = 'flex-start';
AlineacionToJustifyContent[ SalutacionAlineacion[ SalutacionAlineacion.CENTER ] ] = 'center';
AlineacionToJustifyContent[ SalutacionAlineacion[ SalutacionAlineacion.RIGHT ] ] = 'flex-end';

export const TipografiaToClass: { [k:string]: string } = {};
TipografiaToClass[ SalutacionTipografia[ SalutacionTipografia.SANS_SERIF] ] = "sans-serif";
TipografiaToClass[ SalutacionTipografia[ SalutacionTipografia.SERIF] ] = "serif";
TipografiaToClass[ SalutacionTipografia[ SalutacionTipografia.CALIGRAFICA] ] = "caligrafica";


// Documento

export interface Documento {
	id: number,
	nombre: string,
	archivo: number,
	nombreArchivo: string,
	url: string,
	portadaUrl: string,
	seccionAbrev: string,
	fechaUltimaModifAsDesc: string
}